import { Component } from 'preact'
import WidgetPreview from '../components/widget-preview';
import {
    BackgroundFilter,
    LinkFilter,
    OuterWrapperFrameFilter,
    SmallerViewFilter,
    LayoutFilter
} from '../components/filters';
import { __ } from '../../locales'

class WfMicroStar extends Component {
    state = {
        selectedLayout: 'layoutA',
        layoutOptions: [
            {
                label: 'Micro Star Layout A',
                value: 'layoutA'
            },
            {
                label: 'Micro Star Layout B',
                value: 'layoutB'
            },
            {
                label: 'Micro Star Layout C',
                    value: 'layoutC'
            },
            {
                label: 'Micro Star Layout D',
                    value: 'layoutD'
            },
            {
                label: 'Micro Star Layout E',
                    value: 'layoutE'
            },
            {
                label: 'Micro Star Layout F',
                    value: 'layoutF'
            },
            {
                label: 'Micro Star Layout G',
                    value: 'layoutG'
            },
            {
                label: 'Micro Star Layout H',
                    value: 'layoutH'
            },
            {
                label: 'Micro Star Layout I',
                    value: 'layoutI'
            },
        ]
    };


    render(props, state) {
        return (
            <WidgetPreview
                {...props}
                name={__('widget.micro_trust_score_badge.name')}
                description={__('widget.micro_trust_score_badge.description')}
                bestFor={[__('global.homepage'), __('global.header')]}
                type={'micro-star-widget'}
                extraParams={[
                    'slugs',
                    'outerFrame',
                    'background',
                    'smaller',
                    'linkUrl'
                ]}
                layoutType={state.selectedLayout}
                badgeTitle={__('widget.type.badge')}
                badgeColor={'#00897D'}
                badgeFontColor={'#FFFFFF'}
            >
                <div className={'filters-wrapper mt-5 mb-5'}>
                    <LinkFilter
                        {...props}
                        hidden={props.inputs?.profileType === 'specialist' && props.selectedProfiles?.length <= 1}
                    />
                    <LayoutFilter
                        selectedLayout={state.selectedLayout}
                        options={state.layoutOptions}
                        onChange={ev => this.setState({ selectedLayout: ev.target.value })}
                    />
                    <BackgroundFilter {...props} />
                    <OuterWrapperFrameFilter {...props} />
                    <SmallerViewFilter {...props} />
                </div>
            </WidgetPreview>
        );
    }
}

export default WfMicroStar
